import { ConfirmPasswordValidator } from './confirm-password';
import { NgModule } from '@angular/core';

@NgModule({
  imports: [],
  exports: [[ConfirmPasswordValidator]],
  declarations: [ConfirmPasswordValidator],
  providers: []
})
export class ConfirmPasswordModule {}
